import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  FC,
} from 'react';
import { ModalType, IModalStatus } from '../types/modal';

interface ModalContextType {
  modalStatus: IModalStatus;
  setModalStatus: React.Dispatch<React.SetStateAction<IModalStatus>>;
  hideModal: () => void;
}


const ModalContext = createContext<ModalContextType | undefined>(undefined);

const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

const ModalProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [modalStatus, setModalStatus] = useState<IModalStatus>({
    type: null,
    validateAction: null,
  });

  const hideModal = () => setModalStatus({
    type: null,
    validateAction: null,
  });

  return (
    <ModalContext.Provider value={{ modalStatus, setModalStatus, hideModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export { ModalProvider, useModal };
